module.exports = __webpack_public_path__ + "static/media/Ruby-on-rails.d3e2c03a.png";